import { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import ScrollReveal from './ScrollReveal';
import { Search, Lightbulb, Rocket, TrendingUp } from 'lucide-react';
const ProcessSection = () => {
  const sectionRef = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const lineHeight = useTransform(scrollYProgress, [0.15, 0.75], ['0%', '100%']);
  const steps = [{
    icon: Search,
    title: 'Analisi',
    subtitle: 'Settimana 1-2',
    description: 'Studiamo il tuo business, il mercato e la concorrenza. Identifichiamo opportunità nascoste e definiamo obiettivi misurabili.'
  }, {
    icon: Lightbulb,
    title: 'Strategia',
    subtitle: 'Settimana 2-3',
    description: 'Creiamo una roadmap personalizzata con KPI chiari. Ogni azione ha un perché e un risultato atteso.'
  }, {
    icon: Rocket,
    title: 'Esecuzione',
    subtitle: 'Settimana 4+',
    description: 'Implementiamo con precisione, testiamo continuamente, ottimizziamo in tempo reale per massimizzare i risultati.'
  }, {
    icon: TrendingUp,
    title: 'Crescita',
    subtitle: 'Ongoing',
    description: 'Report mensili trasparenti, call strategiche, scaling delle performance. Il tuo successo è il nostro successo.'
  }];
  return <section id="processo" ref={sectionRef} className="section-padding relative overflow-hidden">
      <div className="container-premium">
        <div className="text-center mb-20">
          <ScrollReveal>
            <p className="text-gold tracking-[0.2em] uppercase text-sm mb-6">
              Il nostro processo
            </p>
          </ScrollReveal>
          
          <ScrollReveal delay={0.1}>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl mb-6">
              Come lavoriamo insieme
            </h2>
          </ScrollReveal>
          
          <ScrollReveal delay={0.2}>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Un metodo collaudato che trasforma la complessità in risultati concreti
            </p>
          </ScrollReveal>
        </div>

        <div className="relative max-w-5xl mx-auto">
          {/* Continuous vertical line behind icons - desktop */}
          <div className="hidden md:block absolute left-1/2 top-[40px] bottom-[40px] w-px -translate-x-1/2">
            <div className="w-full h-full bg-border" />
            <motion.div className="absolute top-0 left-0 w-full bg-gold" style={{
            height: lineHeight
          }} />
          </div>

          {/* Continuous vertical line behind icons - mobile */}
          <div className="md:hidden absolute left-[32px] top-[72px] bottom-[72px] w-px">
            <div className="w-full h-full bg-border" />
          </div>

          {/* Steps */}
          <div className="space-y-0">
            {steps.map((step, index) => {
            const isLeft = index % 2 === 0;
            return <ScrollReveal key={step.title} delay={0.2 * index} direction={isLeft ? 'left' : 'right'}>
                  <div className="relative py-8">
                    {/* Mobile/Desktop timeline structure */}
                    <div className={`flex items-center ${isLeft ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                      {/* Content - Left side on desktop for even indexes */}
                      <div className={`hidden md:block md:w-[calc(50%-60px)] ${isLeft ? 'md:text-right md:pr-16' : 'md:text-left md:pl-16'}`}>
                        
                        <h3 className="font-serif text-2xl md:text-3xl mb-4">
                          {step.title}
                        </h3>
                        <p className="text-muted-foreground">
                          {step.description}
                        </p>
                      </div>

                      {/* Center column with icon - fixed width container */}
                      <div className="hidden md:flex w-[120px] justify-center relative z-10">
                        {/* Icon - solid background to cover line */}
                        <div className="w-20 h-20 rounded-2xl bg-background border-2 border-gold/20 flex items-center justify-center shadow-lg">
                          <div className="w-full h-full rounded-xl bg-gold/10 flex items-center justify-center">
                            <step.icon className="w-8 h-8 text-gold" />
                          </div>
                        </div>
                      </div>

                      {/* Empty space for opposite side on desktop */}
                      <div className={`hidden md:block md:w-[calc(50%-60px)] ${isLeft ? 'md:pl-16' : 'md:pr-16'}`} />

                      {/* Mobile layout */}
                      <div className="md:hidden flex items-start gap-4 w-full relative">
                        {/* Icon */}
                        <div className="relative flex flex-col items-center flex-shrink-0">
                          <div className="w-16 h-16 rounded-xl bg-background border-2 border-gold/20 flex items-center justify-center shadow-lg relative z-10">
                            <div className="w-full h-full rounded-lg bg-gold/10 flex items-center justify-center">
                              <step.icon className="w-6 h-6 text-gold" />
                            </div>
                          </div>
                        </div>
                        {/* Content */}
                        <div className="flex-1 pt-2">
                          <p className="text-gold text-sm tracking-wider uppercase mb-2">
                            {step.subtitle}
                          </p>
                          <h3 className="font-serif text-2xl mb-4">
                            {step.title}
                          </h3>
                          <p className="text-muted-foreground">
                            {step.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </ScrollReveal>;
          })}
          </div>
        </div>
      </div>
    </section>;
};
export default ProcessSection;